
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bucketStore } from '@/store';
import _ from 'lodash';

@Component({
  components: {},
})
export default class DialogUploadFileComponent extends Vue {
  @Prop({ default: 'Upload de arquivos' }) readonly propTitle;
  @Prop({ default: false }) readonly propPreview;
  @Prop({ default: 'auto' }) readonly propHeight;
  @Prop({ default: 'Arquivos' }) readonly propButtonName;
  @Prop({ default: '50%' }) readonly propWidth;
  @Prop({ default: false }) readonly propDisabled;
  @Prop({ default: false }) readonly propHover;
  @Prop({ default: false }) readonly propDisableAutoUpload;
  @Prop({ default: true }) readonly propDialog;
  @Prop({
    default: () => ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'text/csv'],
  })
  readonly propAccept;
  @Prop(String) readonly propBucketName;
  @Prop(String) readonly propTableName;
  @Prop(Number) readonly propTableId;
  @Prop({ default: true }) readonly propMultiple;

  @Watch('isOpen')
  async onOpenDialog(isOpen) {
    if (isOpen && !this.propPreview) {
      await this.reloadFiles();
    }
  }

  public isOpen: boolean = false;
  public inputFiles: any[] = [];
  public isLoading = false;

  public headers = [
    { text: 'Preview', value: 'preview' },
    { text: 'Criado em', value: 'created' },
    { text: 'Nome', value: 'name' },
    { text: 'Baixar', value: 'download_url' },
    { text: 'Excluir', value: 'remove' },
  ];

  public files: any[] = [];

  get getFormatosAceitos() {
    return _.map(this.propAccept, (e) => e.split('/')[1].toUpperCase());
  }

  clickOk() {
    this.isOpen = false;
    this.$emit('clickOk');
  }

  public openURL({ download_url }) {
    const a = document.createElement('a');
    a.href = download_url;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public openPreview({ extension, download_url }) {
    if (['jpg', 'jpeg', 'png'].includes(extension)) {
      this.$swal({
        imageUrl: download_url,
        width: 'auto',
        showConfirmButton: false,
      });
    } else {
      this.openURL({ download_url: download_url });
    }
  }

  public async reloadFiles() {
    if (this.propDisableAutoUpload) return;

    this.isLoading = true;
    await bucketStore.getFilesByFilters({
      bucket_name: this.propBucketName,
      table_name: this.propTableName,
      table_id: String(this.propTableId),
      type: '1',
    });
    this.files = _.map(bucketStore.files, (el) => {
      return {
        id: el['blob'].id,
        name: el['blob'].name,
        table_name: el['blob'].table_name,
        full_name: el['blob'].full_name,
        extension: el['blob'].extension,
        created: el['blob'].created,
        updated: el['blob'].updated,
        download_url: el['download_url'],
      };
    });
    this.$emit('filesLoaded', this.files);
    this.isLoading = false;
  }

  public async deleteItem({ full_name, download_url }) {
    await this.$swal({
      icon: 'warning',
      title: 'Excluir arquivo?',
      imageUrl: download_url,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        await bucketStore.deleteFromBucketByName({
          bucket_name: this.propBucketName,
          blob_name: full_name,
        });
        await this.reloadFiles();
      }
    });
  }

  public async uploadFiles(id?: string | number) {
    this.isLoading = true;
    let fileId: null | number = null;
    if (id) {
      fileId = Number(id);
    }
    if (!this.inputFiles || (_.isArray(this.inputFiles) && this.inputFiles.length === 0)) {
      return;
    } else {
      if (_.isArray(this.inputFiles)) {
        await bucketStore.uploadFiles({
          bucket_name: this.propBucketName,
          file_name: this.propTableName,
          file_id: String(fileId || this.propTableId),
          files: this.inputFiles,
        });
      } else {
        await bucketStore.uploadFile({
          bucket_name: this.propBucketName,
          file_name: this.propTableName,
          file_id: String(fileId || this.propTableId),
          file: this.inputFiles,
        });
      }
    }

    this.inputFiles = [];
    await this.reloadFiles();
  }

  public async mounted() {
    this.$on('uploadFiles', (id) => this.uploadFiles(id));
    if (this.propPreview) {
      await this.reloadFiles();
    }
  }
}
